/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Typography, Collapse, Tooltip } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress';

import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';
import  IconButton  from '@material-ui/core/IconButton';
import DeleteOutlined from '@material-ui/icons/DeleteOutline'

import FDropDown from '../../../../fluid/Elements/Inputs/FDropDown'
import Actions from '../../../../fluid/Actions/ActionFactory'

import FlexForm from '../../../FlexForm/FlexForm';

const styles = theme => ({

})

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
          main: '#dc004e',
        },
      },
})

class Action extends Component {
    state = {
        open : true,
        get_params : false,
        fields_in_scope : [],
        params : []
    }

    componentDidMount () {
        console.log('Condition---- Config: ', this.props.config)
        Actions('http_request', {
            url : this.props.field_config.url,
            method: this.props.field_config.method,
            data: this.props.field_config.data,
            params : this.props.field_config.params
        }).then(res => {
            this.setState({...this.state, fields_in_scope : res.data.result}, () => {
                console.log ('Fields In Scope :', res.data.result)
                console.log ('Fields In Scope State :', this.state.fields_in_scope)
            })
        })
    }

    // componentDidUpdate (prevProps, prevState) {
    //     if (prevProps.config.name !== this.props.config.name) {
    //         this.setState({...this.state, get_params : true})
    //     }
    // }

    renderIcon = () => {
        if (this.state.open === true) {
            return (
                <div style = {{marginRight: '10px'}}>
                    <IconButton size = 'small' onClick = {this.handleToggle}>
                        <ExpandLess/>
                    </IconButton>
                </div>
            )
        } else {
            return (
                <div style = {{marginRight: '10px'}}>
                    <IconButton size = 'small' onClick = {this.handleToggle}>
                        <ExpandMore/>
                    </IconButton>
                </div>
            )
        }
    }
    handleToggle = () => {
        this.setState({...this.state, open : !this.state.open})
    }

    renderFieldSelection = () => {
        return (
            <div style = {{width : '25%', margin: '5px'}}>
                <FDropDown
                    key = {this.props.id + 'field'}
                    instance = {{
                        label : 'Action',
                        helper_text : 'Choose the Action to be performed',
                        props : {
                            width : '100',
                            variant : 'standard'
                        },
                        value_store : ["name"],
                        eval_value : '',
                        default_value : this.props.config.name,
                        async_values : true,
                        api_config : {
                            args : {
                                url : this.props.action_config.url,
                                method: this.props.action_config.method,
                                data: this.props.action_config.data,
                                params : this.props.action_config.params
                            },
                            response_key : "result",
                            val_key : "key",
                            label_key : "key"
                        },
                        values : [],
                        render_condition : '',
                        mandatory : true,
                        disabled : this.props.disabled
                    }}
                    handleChange = {(state_key, value) => {
                        this.props.updateAction(this.props.config.id, ["name"], value)
                        this.setState({get_params : true})
                    }}
                />
            </div>
        )
    }

    showParams = () => {
        let params
        console.log('Operator Name: ', this.props.config.name)
        console.log('Condition State: ', this.state)
        if (this.props.config.name !== "") {
            if (this.state.get_params === true) {
                this.getParams()
            }
            params = this.renderParams(this.props.config.params)
        }

        return params
    }

    getParams = () => {
        Actions('http_request', {
            url : this.props.action_params_config.url,
            method: this.props.action_params_config.method,
            data: this.props.action_params_config.data,
            params : {
                ...this.props.action_params_config.params,
                action : this.props.config.name
            }
        }).then (res => {
            this.setState({...this.state, get_params : false})
            this.props.updateAction(this.props.config.id, ["params"], res.data.result)
        })
    }

    renderProgress = () => {
        if (this.state.get_params === true) {
            return (
                <CircularProgress color = 'primary' size = {20}/>
            )
        }
    }

    renderParams = (params) => {
        if (params.length > 0) {
            return (
                <div style = {{display: 'block', width : '100%'}}>
                    <Typography style = {{display : 'block'}} variant = 'overline' color = {this.props.disabled === false ? 'textPrimary' : 'textSecondary'}>Parameters</Typography>
                    <div style = {{width : '100%', display: 'flex', flexDirection : 'row', flexWrap: 'wrap'}}>
                        <FlexForm 
                            config = {this.props.config.params} 
                            fields_in_scope = {this.state.fields_in_scope}
                            update_parent = {(config) => this.props.updateAction(this.props.config.id, ["params"], config)}
                            disabled = {this.props.disabled}
                            grid_element_width = "32%"
                        />
                    </div>
                </div>
            )
        }
    }

    render() {
        const { classes } = this.props
        return (
            <div 
                style = {{
                    backgroundColor : '#FEF1FA', 
                    border: this.props.disabled === false ? '1px solid rgba(255, 93, 205, 1.0)': '1px solid rgba(255, 93, 205, 0.5)',
                    borderRadius :'5px',
                    boxShadow : this.props.disabled === false ? '0 4px 8px 0 rgba(0, 0, 0, 0.1)' : '', 
                    margin: '5px',
                    marginLeft : '15px'
                }}
            >
                <div style ={{width : '100%', margin : '5px', display : 'flex', flexDirection : 'row'}}>
                    <div style = {{flexGrow : 1, cursor : 'pointer'}} onClick = {this.handleToggle}>
                        <Typography variant = 'overline' color = {this.props.disabled === false ? 'textPrimary' : 'textSecondary'}>Action</Typography>
                    </div>
                    <ThemeProvider theme = {blue_theme}>
                        <Tooltip title = 'Delete'>
                            <IconButton 
                                style = {{ 
                                    marginRight : '10px'
                                }} 
                                size = 'small'
                                color = {this.props.disabled === false ? 'secondary' : ''}
                                onClick = {() => this.props.removeAction(this.props.config.id)}
                                disabled = {this.props.disabled}
                            >
                                <DeleteOutlined/>
                            </IconButton>
                        </Tooltip>
                    </ThemeProvider>
                    {this.renderIcon()}
                </div>
                <Collapse in = {this.state.open}>
                    <div style = {{width : '100%', display: 'flex', flexDirection : 'row', flexWrap: 'wrap', margin: '5px', alignItems : 'center'}}>
                        {this.renderFieldSelection()}
                        {this.renderProgress()}
                        {this.showParams()}
                    </div>
                </Collapse>
            </div>
        );
    }
}

export default withStyles(styles)(Action);